import React, { useContext, useState, useEffect } from "react";

import {
  authRequest,
  authRequestNb,
  sendGetRequest,
  fixedNumber,
  refreshToken,
} from "../../../Helper/helper";



const Cryptotabs = () => {
  const [data, setData] = useState();
  const getAutoData = async () => {
    const res = await sendGetRequest("top-loser");
    //console.log("res=>",res.data.gtoken);//
    refreshToken(res.refresh_token);
    setData(res.data);
  };
  useEffect(() => {
    (async () => {
      getAutoData();
    })();
  },[])

  return (
    <div className="table-responsive table-fluid">
  <table className="table latestdesigntable w-25-per">
    <thead>
      <tr>
        <th>Name</th>
        <th>Price(INR)</th>
        <th>Change</th>
       {/*  <th>Last 24H</th> */}
        <th>Volume(INR)</th>
      </tr>
    </thead>
    <tbody>
    {

      (data)?
        (
          data &&
          data.length > 0 &&
          data?.map((coin, i) => (
            <>
              <tr className="">
                <td><a href='/exchange'><img src={coin?.icon} className="img-fluid icon" /> <b>{coin?.currency_symbol.toUpperCase()}</b> {/*  <span>TCC</span> */}</a></td>
                <td>{coin?.price}</td>
                <td><span className="redtext">{parseFloat(coin?.percent_change).toFixed(2)}%</span></td>
                {/* <td>
                  <svg data-v-bb4783ea="" width="90" height="40" viewBox="0 0 90 40" strokeWidth="2" className="trend"><defs><linearGradient id="vue-trend-927" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stopColor="#FA652D"></stop></linearGradient></defs><path d={`M8 ${coin?.Chdata.toString().replaceAll(","," ")}`} fill="none" stroke="url(#vue-trend-927)"></path></svg>
                </td> */}
                <td>{coin?.quote}</td>
              </tr>
            </>
          ))
        )
        :
        <>
         <tr className="">
          <td  colspan="5">

                  Loading...
          </td>
         </tr>
        </>
      }
 {/*    <tr className="">
        <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
        <td>26,599,555</td>
        <td><span className="redtext">-0.78%</span></td>
        <td></td>
        <td>26,599,555</td>
      </tr> */}
      
      {/* 
      <tr className="">
        <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
        <td>26,599,555</td>
        <td><span className="redtext">-0.78%</span></td>
        <td></td>
        <td>26,599,555</td>
      </tr>
      <tr className="">
        <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
        <td>26,599,555</td>
        <td><span className="redtext">-0.78%</span></td>
        <td><svg data-v-bb4783ea="" width="90" height="40" viewBox="0 0 90 40" strokeWidth="2" className="trend"><defs><linearGradient id="vue-trend-927" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stopColor="#FA652D"></stop></linearGradient></defs><path d="M8 8.04246787610619L11.363636363636363 23.207079646017696S11.363636363636363 23.207079646017696 11.363636363636363 23.207079646017696L14.727272727272727 24.991150442477878S14.727272727272727 24.991150442477878 14.727272727272727 24.991150442477878L18.090909090909093 28.346902654867257S18.090909090909093 28.346902654867257 18.090909090909093 28.346902654867257L21.454545454545453 27.072566371681415S21.454545454545453 27.072566371681415 21.454545454545453 27.072566371681415L24.81818181818182 27.2S24.81818181818182 27.2 24.81818181818182 27.2L28.181818181818183 26.4353982300885S28.181818181818183 26.4353982300885 28.181818181818183 26.4353982300885L31.545454545454547 26.81769911504425S31.545454545454547 26.81769911504425 31.545454545454547 26.81769911504425L34.90909090909091 26.30796460176991S34.90909090909091 26.30796460176991 34.90909090909091 26.30796460176991L38.27272727272727 26.4353982300885S38.27272727272727 26.4353982300885 38.27272727272727 26.4353982300885L41.63636363636364 22.315044247787604S41.63636363636364 22.315044247787604 41.63636363636364 22.315044247787604L45 27.2S45 27.2 45 27.2L48.36363636363637 27.2S48.36363636363637 27.2 48.36363636363637 27.2L51.72727272727273 26.4353982300885S51.72727272727273 26.4353982300885 51.72727272727273 26.4353982300885L55.09090909090909 28.346902654867257S55.09090909090909 28.346902654867257 55.09090909090909 28.346902654867257L58.45454545454545 28.856637168141596L61.81818181818182 28.856637168141596S61.81818181818182 28.856637168141596 61.81818181818182 28.856637168141596L65.18181818181819 31.405309734513274S65.18181818181819 31.405309734513274 65.18181818181819 31.405309734513274L68.54545454545455 31.02300884955752S68.54545454545455 31.02300884955752 68.54545454545455 31.02300884955752L71.9090909090909 30.513274336283185S71.9090909090909 30.513274336283185 71.9090909090909 30.513274336283185L75.27272727272728 31.702654867256637S75.27272727272728 31.702654867256637 75.27272727272728 31.702654867256637L78.63636363636364 31.957522123893806L82 31.957532123893806" fill="none" stroke="url(#vue-trend-927)"></path></svg></td>
        <td>26,599,555</td>
      </tr>
      
      <tr className="">
        <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
        <td>26,599,555</td>
        <td><span className="redtext">-0.78%</span></td>
        <td></td>
        <td>26,599,555</td>
      </tr>
      
      <tr className="">
        <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
        <td>26,599,555</td>
        <td><span className="redtext">-0.78%</span></td>
        <td></td>
        <td>26,599,555</td>
      </tr>
      
      <tr className="">
        <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
        <td>26,599,555</td>
        <td><span className="redtext">-0.78%</span></td>
        <td></td>
        <td>26,599,555</td>
      </tr>
      
      <tr className="">
        <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
        <td>26,599,555</td>
        <td><span className="redtext">-0.78%</span></td>
        <td></td>
        <td>26,599,555</td>
      </tr>
      
      <tr className="">
        <td><a href='/exchange'><img src="https://btrlexchange.com/backend/assets/images/currency-logo/tcc.png" className="img-fluid icon" /> <b>The Champcoin Coin</b> <span>TCC</span></a></td>
        <td>26,599,555</td>
        <td><span className="redtext">-0.78%</span></td>
        <td></td>
        <td>26,599,555</td>
      </tr> */}
    </tbody>
  </table>
  </div>
  );
};

export default Cryptotabs;
